import React from "react";
import { trackRegisterClick } from "../../utils/analytics";
import { trackRegisterClick as trackRegisterClickWithPage } from "../../utils/registerClickTracking";
import { useBookNow } from "../../context/BookNowContext";

const About = () => {
  const { openBookNow } = useBookNow();
  return (
    <section className="about-summit-section section-padding">
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-xl-6 col-lg-6 col-12">
            <div className="video-section-content h-100 d-flex flex-column justify-content-center">
              <div
                className="video-wrapper position-relative w-100"
                style={{ paddingTop: "56.25%" }}
              >
                <iframe
                  src="https://www.youtube.com/embed/ecJIhX7ScEU"
                  title="Join the cash flow revolution!"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: "12px",
                  }}
                ></iframe>
              </div>
            </div>
          </div>

          <div className="col-xl-6 col-lg-6 col-12">
            <div className="summit-right-content">
              <div className="info-tag">
                <span className="info-icon">
                  <i className="fa fa-info-circle"></i>
                </span>
                About The Summit
              </div>

              <h2 className="main-heading">
                Master Cash Flow Control & Achieve Financial Freedom
              </h2>

              <p className="description">
                The Cash Flow Summit 2026 is a one-day mega event designed to
                help entrepreneurs, business owners, and professionals master
                the art of cash flow control, financial freedom, and long-term
                stability.
              </p>

              <ul className="summit-details">
                <li>
                  <i className="fa fa-check-circle"></i>
                  Led by CA Jagmohan Singh, India's leading Cash Flow Expert
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  One-day mega event on 11th April 2026
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  At Talkatora Stadium, New Delhi
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  10,000+ Expected Participants
                </li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
